import Snippet from "../../../../contents/docs/integrate/snippet.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import * as React from 'react';
export default {
  Snippet,
  DetailGroupProductsInOneProject,
  DetailSetUpReverseProxy,
  React
};